export const COLORS = {
  lightWhite: "#FBFDFF",
  lightGray: "#F3F5F6",
  mediumGray: "#B0B8BA",
  gray: "#A0A4A6",
  babyBlue: "#50CAF9",
  red: "#d72028",
  darkRed: "#7f181a",
  white: "#fff"
}

export const GRADIENT = `linear-gradient(to top right, ${COLORS.white}, ${
  COLORS.white
})`

export const BORDER_RADIUS = "10px"
